import Vue from 'vue'
import Router from 'vue-router'
// import Error403 from '@/components/Error403'
import MissingLicense from '../components/MissingLicense'
import MainBase from '@/components/MainBase'
import AuthenticateView from '@/components/entry/AuthenticateView'
import ConfigurationView from '@/components/configuration/ConfigurationView'
import GettingStartedView from '@/components/configuration/GettingStartedView'
import IssueViewRequirementsRightPanelView from '../components/webPanels/IssueViewRequirementsRightPanelView'
import LinkRequirementsDialog from '@/components/dialogs/LinkRequirementsDialog'
import ConfluenceLinkedRequirementsMacroView from '@/components/confluence/ConfluenceLinkedRequirementsMacroView'
import ConfluenceLinkedRequirementsMacroEditorView from '@/components/confluence/ConfluenceLinkedRequirementsMacroEditorView'
import ConfluenceInsertRequirementsMacroView from '@/components/confluence/ConfluenceInsertRequirementsMacroView'
import ConfluenceInsertRequirementsMacroEditorView from '@/components/confluence/ConfluenceInsertRequirementsMacroEditorView'
import RequirementsView from '@/components/RequirementsView'
import BaselineView from '@/components/BaselineView'
import TraceabilityMatrixView from '@/components/TraceabilityMatrixView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/403',
    //   name: 'error-403',
    //   component: Error403
    // },
    {
      path: '/authenticate/:location',
      name: 'authenticate',
      component: AuthenticateView
    },
    {
      path: '/configuration',
      meta: {auth: true},
      name: 'configuration',
      component: ConfigurationView
    },
    {
      path: '/issue-view-requirements-right-panel',
      meta: {auth: true},
      name: 'issueViewRequirementsRightPanel',
      component: IssueViewRequirementsRightPanelView
    },
    {
      path: '/link-requirements-dialog',
      meta: {auth: true},
      name: 'linkRequirementsDialog',
      component: LinkRequirementsDialog
    },
    {
      path: '/getting-started',
      meta: {auth: true},
      name: 'gettingStarted',
      component: GettingStartedView
    },
    {
      path: '/confluence-linked-requirements-macro',
      meta: {auth: true},
      name: 'confluenceLinkedRequirementsMacro',
      component: ConfluenceLinkedRequirementsMacroView
    },
    {
      path: '/confluence-linked-requirements-macro-editor',
      meta: {auth: true},
      name: 'confluenceLinkedRequirementsMacroEditor',
      component: ConfluenceLinkedRequirementsMacroEditorView
    },
    {
      path: '/confluence-insert-requirements-macro',
      meta: {auth: true},
      name: 'confluenceInsertRequirementsMacro',
      component: ConfluenceInsertRequirementsMacroView
    },
    {
      path: '/confluence-insert-requirements-macro-editor',
      meta: {auth: true},
      name: 'confluenceInsertRequirementsMacroEditor',
      component: ConfluenceInsertRequirementsMacroEditorView
    },
    {
      path: '/missing-license',
      name: 'missing-license',
      component: MissingLicense
    },
    {
      path: '',
      component: MainBase,
      children: [
        {
          path: '/requirements',
          meta: {auth: true},
          name: 'requirements',
          component: RequirementsView
        }, {
          path: '/traceability-matrix',
          meta: {auth: true},
          name: 'traceabilityMatrix',
          component: TraceabilityMatrixView
        }, {
          path: '/baselines',
          meta: {auth: true},
          name: 'baselines',
          component: BaselineView
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js